/* eslint-disable */
import "jquery";
import 'bootstrap';
import "fuelux/wizard";



// WEBPACK FOOTER //
// ./es6/admin-common-js/config/fuelux-config.js